var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "questionAsk" },
    [
      _c("div", {
        staticClass: "questionAskTitle",
        attrs: { id: "questionAskTitle" },
        domProps: {
          innerHTML: _vm._s(
            _vm.datas.questionDetail.name.replace(/\n/g, "<br>")
          ),
        },
      }),
      _c("div", { staticClass: "questionAskTitleFd" }),
      _vm.isAudio
        ? _c(
            "div",
            { staticClass: "audioDiv" },
            _vm._l(
              _vm.datas.questionDetail.audioPath,
              function (itemAudio, indexAudio) {
                return _c(
                  "audio",
                  {
                    key: indexAudio,
                    staticClass: "sourceAudio",
                    attrs: { controls: "controls" },
                  },
                  [
                    _c("source", {
                      attrs: { src: itemAudio, type: "audio/ogg" },
                    }),
                    _vm._v(
                      " Your browser does not support the audio element. "
                    ),
                  ]
                )
              }
            ),
            0
          )
        : _vm._e(),
      _vm._l(_vm.datas.doTopicDTOS, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "questionAskCenter" },
          [
            item.questionType === "单选题样式"
              ? _c("ChoiceOne", {
                  attrs: {
                    isAnalysis:
                      _vm.isAnalysis || _vm.$route.query.topicLx === "topicLx",
                    index: _vm.topicLx ? index + 1 : item.topicNum,
                    datas: item,
                    isDisabled: _vm.isDisabled,
                  },
                  on: { showAnalysis: _vm.showAnalysisCl },
                })
              : _vm._e(),
            item.questionType === "填空题样式"
              ? _c("FillBlank", {
                  attrs: {
                    isAnalysis:
                      _vm.isAnalysis || _vm.$route.query.topicLx === "topicLx",
                    index: _vm.topicLx ? index + 1 : item.topicNum,
                    datas: item,
                    isDisabled: _vm.isDisabled,
                  },
                  on: { showAnalysis: _vm.showAnalysisCl },
                })
              : _vm._e(),
            item.questionType === "判断题样式" ||
            item.questionType === "阅读判断题样式"
              ? _c("Judge", {
                  attrs: {
                    isAnalysis:
                      _vm.isAnalysis || _vm.$route.query.topicLx === "topicLx",
                    index: _vm.topicLx ? index + 1 : item.topicNum,
                    datas: item,
                    isDisabled: _vm.isDisabled,
                  },
                  on: { showAnalysis: _vm.showAnalysisCl },
                })
              : _vm._e(),
            item.questionType === "多选题样式"
              ? _c("ChoiceMultiple", {
                  attrs: {
                    isAnalysis:
                      _vm.isAnalysis || _vm.$route.query.topicLx === "topicLx",
                    index: _vm.topicLx ? index + 1 : item.topicNum,
                    datas: item,
                    isDisabled: _vm.isDisabled,
                  },
                  on: { showAnalysis: _vm.showAnalysisCl },
                })
              : _vm._e(),
            item.questionType === "简答题样式"
              ? _c("Subjective", {
                  attrs: {
                    isAnalysis:
                      _vm.isAnalysis || _vm.$route.query.topicLx === "topicLx",
                    index: _vm.topicLx ? index + 1 : item.topicNum,
                    datas: item,
                    isDisabled: _vm.isDisabled,
                  },
                  on: { showAnalysis: _vm.showAnalysisCl },
                })
              : _vm._e(),
            _c("QuestionAnalysis", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAnalysisDt || _vm.showAnalysisAsy === item.id,
                  expression: "isAnalysisDt || showAnalysisAsy === item.id",
                },
              ],
              ref: "questionAnalysis",
              refInFor: true,
              attrs: { analysisDatas: item },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }